import { Chip, TextField } from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import AppContainer from "../../components/layout/AppContainer";
import withTitle from "../../helpers/hoc/withTitle";
import { TicketLogsGetAll } from "../../api/api";
import CustomDataGrid from "../../components/CustomDataGrid";
import GetDataArea from "../../components/GetDataArea";
import Grid from "@mui/material/Unstable_Grid2";
import dayjs from "dayjs";

const STATUS = {
  activationStarted: { text: "Aktivasyon Başladı", color: "secondary" },
  serviceStarted: { text: "Hizmet Başladı", color: "success" },
  serviceFinished: { text: "Hizmet Bitti", color: "info" },
  cancellationPending: {
    text: "İptali Bekleniyor",
    color: "warning",
    variant: "outlined",
  },
  cancellationAccepted: {
    text: "İptali Onaylandı",
    color: "success",
    variant: "outlined",
  },
  cancellationRejected: {
    text: "İptali Reddedildi",
    color: "error",
    variant: "outlined",
  },
};
function TicketLog() {
  const breadcrumb = useMemo(
    () => [{ name: <FormattedMessage id="reports.ticketLog" />, active: true }],
    []
  );

  const biletColumns = useMemo(
    () => [
      {
        field: "Id",
        headerName: "ID",
        minWidth: 75,
      },
      {
        field: "BiletReferansKodu",
        headerName: "Bilet Numarası",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "SepetReferansKodu",
        headerName: "Sepet Referans Kodu",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "AdSoyad",
        headerName: "Müşteri Ad Soyad",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "IslemTarihi",
        headerName: "İşlem Tarihi",
        minWidth: 150,
        flex: 1,
        type: "dateTime",
        renderCell: (params) => {
          return dayjs(params.value).format("DD.MM.YYYY HH:mm");
        },
      },
      {
        field: "ModifyUser",
        headerName: "Düzenleyen Kişi",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "Durum",
        headerName: "Durum",
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          if (params.value) {
            return (
              <Chip
                size="small"
                label={STATUS[params.value]?.text}
                color={STATUS[params.value]?.color}
                variant={STATUS[params.value]?.variant || "filled"}
              />
            );
          } else {
            return "-";
          }
        },
      },
      {
        field: "SeferTarihi",
        headerName: "Sefer Tarihi",
        minWidth: 150,
        flex: 1,
        type: "dateTime",
        renderCell: (params) => {
          if (params.value) {
            return dayjs(params.value).format("DD.MM.YYYY HH:mm");
          } else {
            return "-";
          }
        },
      },
      {
        field: "OtobusPlakasi",
        headerName: "Otobüs Plakası",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "Route",
        headerName: "Güzergah",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "Station",
        headerName: "Durak",
        minWidth: 150,
        flex: 1,
      },
    ],
    []
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  //GET DATA FILTERS
  const [ticketRefNo, setTicketRefNo] = useState("");
  const [refCode, setRefCode] = useState("");
  const [customerNameSurname, setCustomerNameSurname] = useState("");

  const HandleSearchClick = useCallback(async () => {
    setLoading(true);
    await TicketLogsGetAll({
      ...(ticketRefNo !== "" && {
        BiletReferansKodu: ticketRefNo,
      }),
      ...(refCode !== "" && {
        SepetReferansKodu: refCode,
      }),
      ...(customerNameSurname !== "" && {
        MusteriAdSoyad: customerNameSurname,
      }),
      Filter: "BiletHareketleri",
    })
      .then((resp) => {
        setData(
          resp.data.data.map(
            ({ SatisId, ModifyUserId, SeferId, RouteId, StationId, ...rest }) =>
              rest
          )
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [ticketRefNo, refCode, customerNameSurname]);
  const HandleDeleteClick = useCallback(async () => {
    setTicketRefNo("");
    setRefCode("");
    setCustomerNameSurname("");
  }, []);
  return (
    <AppContainer breadcrumbs={breadcrumb}>
      <GetDataArea
        HandleSearchClick={HandleSearchClick}
        HandleDeleteClick={HandleDeleteClick}
        dateFilter={false}
      >
        <Grid xs={12} lg={2}>
          <TextField
            fullWidth
            size="small"
            label="Bilet Numarası"
            value={ticketRefNo}
            onChange={(e) => setTicketRefNo(e.target.value)}
          />
        </Grid>
        <Grid xs={12} lg={2}>
          <TextField
            fullWidth
            size="small"
            label="Referans Kodu"
            value={refCode}
            onChange={(e) => setRefCode(e.target.value)}
          />
        </Grid>
        <Grid xs={12} lg={2}>
          <TextField
            fullWidth
            size="small"
            label="Müşteri Ad-Soyad"
            value={customerNameSurname}
            onChange={(e) => setCustomerNameSurname(e.target.value)}
          />
        </Grid>
      </GetDataArea>
      <CustomDataGrid
        data={data}
        columns={biletColumns}
        loading={loading}
        allowEditDelete={false}
        getRowId={(row) => row.Id}
        rowsUniqueId="Id"
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "IslemTarihi",
                sort: "desc",
              },
            ],
          },
        }}
      />
    </AppContainer>
  );
}

export default withTitle(TicketLog, "reports.ticketLog");
